import '../../styles-new/pages/structure.scss';